<script>
	import { createEventDispatcher, onDestroy, onMount } from 'svelte';
	import Icon from './Icon.svelte';

	export let className = 'md:w-2/3 lg:w-1/3 mx-2 md:mx-auto';
	export let bg = true;
	export let prompt = false;

	const dispatch = createEventDispatcher();
	const close = () => dispatch('close');

	let modal;

	const handle_keydown = (e) => {
		if (e.key === 'Escape') {
			close();
			return;
		}

		if (e.key === 'Tab') {
			// trap focus
			const nodes = modal.querySelectorAll('*');
			const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

			let index = tabbable.indexOf(document.activeElement);
			if (index === -1 && e.shiftKey) index = 0;

			index += tabbable.length + (e.shiftKey ? -1 : 1);
			index %= tabbable.length;

			tabbable[index].focus();
			e.preventDefault();
		}
	};

	const previously_focused = typeof document !== 'undefined' && document.activeElement;

	if (previously_focused) {
		onDestroy(() => {
			if (previously_focused) {
				previously_focused.focus();
			}
		});
	}

	onMount(() => {
		modal.scrollIntoView();
	});
</script>

<svelte:window on:keydown={handle_keydown} />

<div
	class="fixed inset-0 bg-black bg-opacity-50 cursor-default overflow-y-auto"
	style="margin: 0; padding: 0;"
	on:mousedown|self={close}
	role="none"
	class:z-30={!prompt}
	class:z-40={prompt}
>
	<div
		class="absolute inset-0 mt-12 lg:mx-auto inset-x-0 {className}"
		class:z-40={!prompt}
		class:z-50={prompt}
		on:mousedown|self={close}
		role="none"
	>
		<div
			class:bg-white={bg}
			class:p-2={bg}
			class="text-gray-700 rounded"
			role="dialog"
			aria-modal="true"
			bind:this={modal}
		>
			<button on:click|preventDefault={close} class="absolute top-0 right-0 mt-2 mr-2">
				<Icon name="close" classes="w-6 h-6 text-gray-700" />
			</button>
			<slot name="header" />
			<slot />
		</div>
	</div>
</div>
